<interactive-toast [key]="'dashboard'"></interactive-toast>
<div class="mx-4 md:mx-[24px] text-xl md:text-[22px] xlplus:text-2xl font-semibold">My Dashboard</div>
<!--
  "Successful Conversions" counts Phase 2 only by nature — a Phase 1
  conversion never reaches Success (BE-confirmed; see the isPhase1/isPhase2
  note in src/types/commons.ts). "To Be Reviewed" spans both phases. Counts
  come from ConversionStatusService.fetchConversionStatusCount.
-->
<div class="flex flex-col lg:flex-row gap-4 mt-6 mx-4 md:mx-[24px]">
  <div class="flex flex-col gap-4 w-full lg:w-1/2">
    <div class="flex flex-col sm:flex-row gap-4">
      <dashboard-conversion-summary
        class="flex-1"
        [icon]="'success'"
        [alt]="'Success Upload'"
        [content]="'Successful Conversions'"
        [count]="successCount()"
        [isLoading]="isLoading()"
      ></dashboard-conversion-summary>
      <!-- <dashboard-conversion-summary
        class="flex-1"
        [icon]="'failed'"
        [alt]="'Failed Upload'"
        [content]="'Failed Conversions'"
        [count]="failedCount()"
        [isLoading]="isLoading()"
      ></dashboard-conversion-summary> -->
      <dashboard-conversion-summary
        class="flex-1"
        [icon]="'review'"
        [alt]="'To Be Reviewed'"
        [content]="'To Be Reviewed'"
        [count]="reviewCount()"
        [isLoading]="isLoading()"
      ></dashboard-conversion-summary>
    </div>
    <dashboard-xbrl-form></dashboard-xbrl-form>
  </div>
  <div class="w-full lg:w-1/2">
    <dashboard-recent-conversion></dashboard-recent-conversion>
  </div>
</div>
